import { Filter, TaskFilter, EditionsFilter, UserFilter, StandardsFilter } from 'global/utils/filter';
import { get } from 'global/lib/lodash';
import { CourseStatus, DateRanges, EditionStatus, Ownership, OwnershipTask, QualityType, RealmTypes, TaskContent, TaskStatus } from '../../lib/filter';

export const FILTERDEFAULTS = {
  reports: {
    list: Filter(),
    data: Filter(),
    photo: Filter({ superset_id: null, user_id: null, quality_type: 1 }),
  },
  tasks: {
    list: TaskFilter(),
    age: TaskFilter({ _sort: { sortBy: 'created_at' } }),
    realm: TaskFilter({ ownership: 'all' }),
  },
  library: {
    editions: EditionsFilter({ useLocation: true }),
    courses: EditionsFilter(),
    standards: StandardsFilter(),
  },
  users: {
    manage: UserFilter(),
    courses: UserFilter({ report_type: 'user' }),
  },
  alerts: {
    user: { locationOn: false },
    all: { locationOn: false },
  },
};

export const Definitions = {
  tasks: {
    list: {
      status: TaskStatus,
      ownership: OwnershipTask,
      content: TaskContent,
      vendor_id: (val, { vendors }) => {
        return get(
          get(vendors, 'data', []).find((s) => s.vendorId == val),
          'vendor.name',
          'N/A'
        );
      },
    },
    age: {
      status: TaskStatus,
      ownership: OwnershipTask,
      content: TaskContent,
      vendor_id: (val, { vendors }) => {
        return get(
          get(vendors, 'data', []).find((s) => s.vendorId == val),
          'vendor.name',
          'N/A'
        );
      },
    },
    realm: {
      includeRealm: false,
      status: TaskStatus,
      ownership: OwnershipTask,
      content: TaskContent,
      vendor_id: (val, { vendors }) => {
        return get(
          get(vendors, 'data', []).find((s) => s.vendorId == val),
          'vendor.name',
          'N/A'
        );
      },
    },
  },
  reports: {
    list: {
      realm_type: RealmTypes,
      ownership: Ownership,
      scorecard_id: (val, { sState }) => {
        return get(
          get(sState, 'data.scorecards', []).find((s) => s.id == val),
          'name',
          'N/A'
        );
      },
      daterange: DateRanges,
      vendor_id: (val, { vendors }) => {
        return get(
          get(vendors, 'data', []).find((s) => s.vendorId == val),
          'vendor.name',
          'N/A'
        );
      },
    },
    data: {
      realm_type: RealmTypes,
      ownership: Ownership,
      daterange: DateRanges,
      edition_id: (val, { sState }) => {
        return get(
          get(sState, 'data.latesteditions', []).find((s) => s.id == val),
          'name',
          'N/A'
        );
      },
      scorecard_id: (val, { sState }) => {
        return get(
          get(sState, 'data.scorecards', []).find((s) => s.id == val),
          'name',
          'N/A'
        );
      },
      vendor_id: (val, { vendors }) => {
        if (!val) { return '' }
        return get(
          get(vendors, 'data', []).find((s) => s.vendorId == val),
          'vendor.name',
          'N/A'
        );
      },
    },
    photo: {
      realm_type: RealmTypes,
      daterange: DateRanges,
      ownership: Ownership,
      scorecard_id: (val, { sState }) => {
        return get(
          get(sState, 'data.scorecards', []).find((s) => s.id == val),
          'name',
          'N/A'
        );
      },
      vendor_id: (val, { vendors }) => {
        return get(
          get(vendors, 'data', []).find((s) => s.vendorId == val),
          'vendor.name',
          'N/A'
        );
      },
      superset_id: (val, { supersets }) => {
        return get(
          get(supersets, 'data', []).find((s) => s.id == val),
          'name',
          'N/A'
        );
      },
      user_id: (val, { users }) => {
        return get(
          get(users, 'data', []).find((s) => s.id == val),
          'name',
          'N/A'
        );
      },
      quality_type: QualityType,
    },
  },
  library: {
    editions: {
      includeRealm: false,
      status: EditionStatus,
      courseStatus: CourseStatus,
      user_groups: (val) => {
        return null;
      },
    },
    courses: {
      includeRealm: false,
      status: EditionStatus,
      courseStatus: CourseStatus,
      edition_id: (val) => {
        return get(
          get(window, 'EDITIONSDATA', []).find((e) => e.id == val),
          'name',
          'N/A'
        );
      },
      role: [{ title: 'For Review', value: 'reviewer' }],
    },
  },
};
